import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
export function CountdownSection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-10 md:py-14 px-4 bg-brand-navy border-y-4 border-brand-primary" data-id="element-60">
      <div className="max-w-4xl mx-auto text-center" data-id="element-61">
        <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-62">
          ⏰ Esta oferta cierra cuando el contador llegue a cero.
        </h2>

        <div className={`flex justify-center gap-4 md:gap-8 mb-8 mt-10 ${isUrgent ? 'animate-blink' : ''}`} data-id="element-63">
          <div className="flex flex-col items-center" data-id="element-64">
            <div className={`text-6xl md:text-8xl font-black p-4 md:p-6 rounded-2xl shadow-inner min-w-[100px] md:min-w-[140px] ${isUrgent ? 'bg-red-600 text-white' : 'bg-brand-deep border border-white/10 text-white'}`} data-id="element-65">
              {formatTime(minutes)}
            </div>
            <span className="text-blue-200 font-bold mt-3 uppercase tracking-widest" data-id="element-66">
              min
            </span>
          </div>
          <div className="text-6xl md:text-8xl font-black text-white self-start mt-2 md:mt-4" data-id="element-67">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-68">
            <div className={`text-6xl md:text-8xl font-black p-4 md:p-6 rounded-2xl shadow-inner min-w-[100px] md:min-w-[140px] ${isUrgent ? 'bg-red-600 text-white' : 'bg-brand-primary text-white'}`} data-id="element-69">
              {formatTime(seconds)}
            </div>
            <span className="text-blue-200 font-bold mt-3 uppercase tracking-widest" data-id="element-70">
              seg
            </span>
          </div>
        </div>

        <p className="text-2xl font-bold text-red-400 mb-10" data-id="element-71">
          🔴 Después vuelve a $49.900 ARS — sin excepciones.
        </p>

        <div className="max-w-xl mx-auto" data-id="element-72">
          <CTAButton text="→ ASEGURAR MI PRECIO AHORA" href="#empezar" isLink={true} data-id="element-73" />
        </div>
      </div>
    </section>;
}